// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IAttachment {
    'type'?: string;
    'pdf'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IAttachment>> = [
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "pdf",
            "baseName": "pdf",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return IAttachment.attributeTypeMap;
    }
}
